import axios from "axios";
// import { encryptText, decryptText } from "../../../helpers/Confidential";
import store from "../../../store/index";
import { getModuleName } from "./moduleSentApi"; // Function to get module name
import { showToaster } from "../common";

const axiosInstance = axios.create({
  baseURL: "",
  timeout: 10000,
  withCredentials: true
});

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const state = store.getState();
//     const auth = state.Login.user;
//     let data = config.data || {};

//     // Automatically get module name based on current route
//     const moduleName = getModuleName(); // Function to fetch module name dynamically
//     if (moduleName !== false) {
//       data.module = moduleName; // Attach module name to request payload


//     }

//     if (auth?.authToken) {
//       config.headers["Authorization"] = `Bearer ${auth?.authToken}`;
//       data.acToken = auth?.accessToken;
//     }
//     config.headers["Content-Type"] = "application/json";
//     config.data = data;

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//   (response) => {
//     if (response?.data) {
//       try {

//         return response.data;
//       } catch (error) {
//         return Promise.reject(new Error("Decryption failed"));

//       }
//     }
//     return response;
//   },
//   (error) => {
//     if (error.response?.status === 503) window.location.href = "/maintenance";
//     if (error.response?.status === 403) window.location.href = "/blocked";
//     if (error.response?.status === 401 || error.response?.status === 302) {


//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
